<template>
  <div>
    <div class="head-title">标签拉群</div>
    <el-collapse >
  <el-collapse-item title="帮助标签" name="1">
   <div class="help">
      <p>
        1、新建标签拉群任务，选择添加企业客户标签，设置邀请入群内容和对应的群活码（客户群活码），对应标签客户收到进群邀请后，点击进群。<a
          class="help-link"
          href="https://www.weijub.com/index/index/news_detail?id=122"
          target="_blank"
          rel="noopener noreferrer"
          >使用教程</a
        >
      </p>
      <p>
        2、按照企业客户的标签建立客户群，使得同一标签的客户在同一个群内，他们有相同的兴趣爱好和话题，后期针对相同属性的客户群制定更精准的群运营方案，让社群运营起来更精细化。
      </p>
    </div>
  </el-collapse-item>
    </el-collapse>

    <div class="mMain">
      <nav class="navbar">
        <div class="nav-l">
          <el-button type="primary" icon="el-icon-plus" @click="onAdd"
            >新建标签拉群</el-button
          >
          <el-button
            style="margin-left: 2.4rem"

            icon="el-icon-delete"
            @click="onDels"
            >批量删除</el-button
          >
        </div>
        <div class="nav-r">
          <el-input
            v-model="q"
            style="width: 35.0rem; "
            prefix-icon="el-icon-search"
            placeholder="请输入任务名称搜索"
            clearable=""
            @change="getData"
          >
          <el-button type="primary" slot="append" @click="getData"
            >查询</el-button
          >
          </el-input>

        </div>
      </nav>
      <div class="container">
        <el-table
          :data="list"
          v-loading="tableLoading"
          style="margin-top: 2.0rem"
          border

          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            prop="name"
            label="任务名称"
            style="width:14.28%"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="group_label" label="客户标签" style="width:14.28%">
            <template slot-scope="scope">
              <div>
                <el-tag
                  size="mini"
                  style="margin: .2rem"
                  v-for="i in scope.row.group_label"
                  :key="i"
                  >{{ i }}</el-tag
                >
              </div>
            </template>
            <template slot-scope="scope">
              <el-popover placement="left" trigger="hover">
                <template>
                  <div class="set-popper" v-html="scope.row.group_label"></div>
                </template>
                <div slot="reference">
                  <div
                    v-if="
                      scope.row.group_label[0] == '暂无' &&
                      scope.row.group_label.length == 1
                    "
                  >
                    {{ scope.row.group_label[0] }}
                  </div>
                  <div v-else class="set-content">
                    <el-tag
                      size="mini"
                      style="margin: .2rem"
                      v-for="(i, index) in scope.row.group_label"
                      :key="index"
                      >{{ i }}</el-tag
                    >
                  </div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-tab-column show-overflow-tooltip prop="content" label="入群内容">
          </el-tab-column>

          <el-table-column prop="user_name" label="客户归属" style="width:14.28%">
            <template slot-scope="scope">
              <div>
                <el-tag
                  size="mini"
                  style="margin: .2rem"
                  v-for="i in scope.row.user_name"
                  :key="i"
                  >{{ i }}</el-tag
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="qr_code" label="活码图片" style="width:14.28%">
            <template slot-scope="scope">
              <el-image
                style="width: 7.0rem; height: 7.0rem"
                :src="scope.row.url"
                :preview-src-list="[scope.row.url]"
                fit="scale-down"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" style="width:14.28%">
            <template slot-scope="scope">
              <template>
                <el-tag type="success" size="mini" v-if="scope.row.status === '成功'" >{{ scope.row.status }}</el-tag>
                <el-tag   type="danger"  size="mini" v-else >{{ scope.row.status }}</el-tag>
                <!-- <span
                  :style="{
                    color: scope.row.status === '成功' ? '#67C23A' : '#F56C6C',
                  }"
                >
                  {{ scope.row.status }}
                </span> -->
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="createtime" label="创建时间" style="width:14.28%">
          </el-table-column>
          <el-table-column label="操作" fixed="right"  width="200">
            <template slot-scope="scope">
              <!-- <el-button type="primary" size="mini" @click="onDetail(scope.row)">
                查看
              </el-button> -->
              <el-button type="text" size="mini">
                <a
                  :href="`https://api.weijub.com/crm/ActiveCode/getImages?url=${scope.row.url}&usertoken=${tooken.usertoken}`"
                  style="color: #317af8"
                  :download="`活码`"
                  >下载</a
                >
              </el-button>
              <el-button @click="onDel(scope.row)" size="mini" type="text" style="color:#f00000 !important">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paging">
          <pagination
            :total="total"
            :page.sync="listQuery.page"
            :limit.sync="listQuery.limit"
            :page-sizes="[10,20,50,100]"
            @pagination="getData"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "setGroups",
  data() {
    return {
      list: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      q: "",
      multipleSelection: "",
      tableLoading: true
    };
  },

  components: {},

  computed: {},

  mounted() {
    this.getData();
  },

  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onAdd() {
      this.$router.push({
        name: "tagSetGroupDetail",
      });
    },
    async getData() {
      const { data: res } = await this.axios({
        url: "/crm/AssistantLabel/getMassList",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          name: this.q,
          page: this.listQuery.page,
          number_page:this.listQuery.limit,
        }),
      });
      this.tableLoading = false;
      if (res.code == 1) {
        this.list = res.data.data;
        this.total = res.data.total;
      }
    },
    async onDetail(row) {
      this.$router.push({
        name: "tagSetGroupDetail",
        query: {
          id: row.id,
        },
      });
    },
    onDels() {
      if (this.multipleSelection.length > 0) {
        this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            const ids = this.multipleSelection.map((i) => i.id);
            this.del(String(ids));
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message("请选择您要删除的任务");
      }
    },
    onDel(row) {
      this.$confirm("此操作将永久删除该条数据，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.del(row.id);
        })
        .catch(() => {
          this.$message({
            message: "已取消删除",
            type: "info",
          });
        });
    },
    async del(ids) {
      const { data: res } = await this.axios({
        url: "/crm/AssistantLabel/delMass",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          ids,
        }),
      });
      if (res.code == 1) {
        this.$message({
          message: "删除成功",
          type: "success",
        });
        this.getData();
      } else if (res.code == 0) {
        this.$message.error(res.msg);
      }
    },
  },
};
</script>
<style  scoped>
.el-button--text{padding-left:.0rem !important;}
</style>
